import GoodsReturnDetail from "./GoodsReturnDetail";

export default GoodsReturnDetail;
